import script from "./PaperList.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperList.vue?vue&type=script&setup=true&lang=js"

import "./PaperList.vue?vue&type=style&index=0&id=9cdebf70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cdebf70"]])

export default __exports__